require("./../app");

import {BREAKPOINTS} from "../support/constants";
import store from "../store/store";
import Vue from "vue";

Vue.component('accordion-panel', require('./../components/Universal/AccordionPanel.vue').default);
Vue.component("breadcrumb", require("../components/Universal/Breadcrumb.vue").default);

new Vue({
  el: "#app",
  mq: BREAKPOINTS,
  store: store,
});
